import moment from "moment";

const FORMAT = 'YYYY-MM-DD';

export const PERIOD_PRESETS = [
    { value: 'day', label: 'Hoje' },
    { value: 'week', label: 'Esta semana' },
    { value: 'month', label: 'Este mês' },
    { value: 'year', label: 'Este ano' },
    { value: 'last30', label: 'Últimos 30 dias' },
    { value: 'last12m', label: 'Últimos 12 meses' },
    { value: 'all', label: 'Todo o período' },
];

export const DEFAULT_PERIOD = 'month';

// O preset é a unidade em que as setas andam: escolhido "Este mês", a seta
// vai para o mês anterior e o rótulo vira "Setembro de 2026".
export const resolvePeriod = (preset, reference = moment()) => {
    const today = moment(reference);

    switch (preset) {
        case 'day':
            return { preset, start: today.format(FORMAT), end: today.format(FORMAT) };
        case 'week':
            return { preset, start: today.clone().startOf('isoWeek').format(FORMAT), end: today.clone().endOf('isoWeek').format(FORMAT) };
        case 'year':
            return { preset, start: today.clone().startOf('year').format(FORMAT), end: today.clone().endOf('year').format(FORMAT) };
        case 'last30':
            return { preset, start: today.clone().subtract(29, 'days').format(FORMAT), end: today.format(FORMAT) };
        case 'last12m':
            return { preset, start: today.clone().subtract(12, 'months').add(1, 'day').format(FORMAT), end: today.format(FORMAT) };
        case 'all':
            return { preset, start: '', end: '' };
        default:
            return { preset: 'month', start: today.clone().startOf('month').format(FORMAT), end: today.clone().endOf('month').format(FORMAT) };
    }
};

const UNITS = { day: 'day', week: 'week', month: 'month', year: 'year', last12m: 'month' };

export const shiftPeriod = (period, direction) => {
    if (period.preset === 'all' || !period.start || !period.end) return period;

    const start = moment(period.start);
    const end = moment(period.end);

    if (['month', 'year'].includes(period.preset)) {
        const unit = UNITS[period.preset];
        const next = start.clone().add(direction, unit);
        return { ...period, start: next.clone().startOf(unit).format(FORMAT), end: next.clone().endOf(unit).format(FORMAT) };
    }

    if (period.preset === 'last12m') {
        return { ...period, start: start.add(direction * 12, 'months').format(FORMAT), end: end.add(direction * 12, 'months').format(FORMAT) };
    }

    const days = end.diff(start, 'days') + 1;

    return { ...period, start: start.add(direction * days, 'days').format(FORMAT), end: end.add(direction * days, 'days').format(FORMAT) };
};

const capitalize = text => text.charAt(0).toUpperCase() + text.slice(1);

export const getPeriodLabel = period => {
    if (period.preset === 'all' || (!period.start && !period.end)) return 'Todo o período';

    const start = moment(period.start).locale('pt-br');
    const end = moment(period.end).locale('pt-br');

    if (period.preset === 'day') {
        return start.isSame(moment(), 'day') ? `Hoje, ${start.format('DD/MM/YYYY')}` : start.format('DD/MM/YYYY');
    }

    if (period.preset === 'month') return capitalize(start.format('MMMM [de] YYYY'));
    if (period.preset === 'year') return start.format('YYYY');

    if (period.preset === 'week') return `${start.format('DD/MM')} – ${end.format('DD/MM/YYYY')}`;

    return `${start.format('DD/MM/YYYY')} – ${end.format('DD/MM/YYYY')}`;
};
